<template>
  <Button v-if="!subscribed" href="/pro/checkout" primary
    ><slot name="text">Subscribe</slot></Button
  >
  <slot v-else />
</template>
<script setup lang="ts">
const subscribed = isSubscriber();
</script>
